import { Bold, Heading2, Italic, List, ListOrdered, Redo2, Undo2 } from 'lucide-vue-next'

export const TIPTAP_ACTION_GROUPS = {
  FORMATTING: 'formatting',
  INSERT: 'insert',
  STRUCTURE: 'structure',
  HISTORY: 'history',
}

export const useTiptapToolbarActions = (options = {}) => {
  const normalizedOptions = typeof options === 'number'
    ? { headingLevel: options }
    : options
  const headingLevel = normalizedOptions.headingLevel ?? 2

  return [
    {
      key: 'bold',
      label: 'Bold',
      icon: Bold,
      group: TIPTAP_ACTION_GROUPS.FORMATTING,
      execute: (chain) => chain.toggleBold(),
      isActive: (editor) => editor.isActive('bold'),
    },
    {
      key: 'italic',
      label: 'Italic',
      icon: Italic,
      group: TIPTAP_ACTION_GROUPS.FORMATTING,
      execute: (chain) => chain.toggleItalic(),
      isActive: (editor) => editor.isActive('italic'),
    },
    {
      key: 'heading',
      label: 'Heading',
      icon: Heading2,
      group: TIPTAP_ACTION_GROUPS.STRUCTURE,
      execute: (chain) => chain.toggleHeading({ level: headingLevel }),
      isActive: (editor) => editor.isActive('heading', { level: headingLevel }),
    },
    {
      key: 'bullet-list',
      label: 'Bullets',
      icon: List,
      group: TIPTAP_ACTION_GROUPS.STRUCTURE,
      execute: (chain) => chain.toggleBulletList(),
      isActive: (editor) => editor.isActive('bulletList'),
    },
    {
      key: 'ordered-list',
      label: 'Numbers',
      icon: ListOrdered,
      group: TIPTAP_ACTION_GROUPS.STRUCTURE,
      execute: (chain) => chain.toggleOrderedList(),
      isActive: (editor) => editor.isActive('orderedList'),
    },
    {
      key: 'undo',
      label: 'Undo',
      icon: Undo2,
      group: TIPTAP_ACTION_GROUPS.HISTORY,
      execute: (chain) => chain.undo(),
      isActive: () => false,
    },
    {
      key: 'redo',
      label: 'Redo',
      icon: Redo2,
      group: TIPTAP_ACTION_GROUPS.HISTORY,
      execute: (chain) => chain.redo(),
      isActive: () => false,
    },
  ]
}
